import { getUserInfo, getAuthorInfo } from '@/api/account'
import { getBalance } from '@/api/vcurrency'

export const namespaced = true

export const state = () => ({
  /**
   * 用户基础信息
   */
  userInfo: null,
  authorInfo: null,
  /**
   * 财币数量
   */
  balance: { assetType: 0, balance: 0 }
})

export const getters = {
  /**
  * 是否是大咖
  * @param state
  * @return {boolean}
  */
  isAuthor: state => {
    let _isAuthor = false

    if (state.authorInfo && (state.authorInfo.validstatus === 1 || state.authorInfo.validstatus === 3)) {
      _isAuthor = true
    }
    return _isAuthor
  },
  /**
    * 是否大咖资料编辑中
    * @param state
    * @return {boolean}
    */
  isEditing: state => {
    let _isAuthor = false

    if (!state.authorInfo || state.authorInfo.checkstatus === 0 || state.authorInfo.checkstatus === 2) {
      _isAuthor = true
    }
    return _isAuthor
  }
}

export const mutations = {
  setUserInfo: function (state, userInfo) {
    state.userInfo = userInfo
  },
  setBalance: function (state, balance) {
    state.balance = balance
  },
  setAuthorInfo: function (state, authorInfo) {
    state.authorInfo = authorInfo
  }
}

export const actions = {
  async getUserInfo({ state, commit }, flush = true) {
    if (flush || !state.userInfo) {
      const userInfo = await getUserInfo()
      commit('setUserInfo', userInfo)
    }
  },
  async getAuthorInfo({ state, commit }, flush = true) {
    if (flush || !state.authorInfo) {
      const authorInfo = await getAuthorInfo()
      commit('setAuthorInfo', authorInfo)
    }
  },
  async getBalance({ commit }) {
    const balances = await getBalance()

    const balance = balances.find(value => value.assetType === 0)

    commit('setBalance', balance)
  }
}
